"use strict";
var $ = require("../internals/export");
var $transfer = require("../internals/array-buffer-transfer");
if ($transfer) $({ target: "ArrayBuffer", proto: true }, {
  transfer: function transfer() {
    return $transfer(this, arguments.length ? arguments[0] : void 0, true);
  }
});
